import { showConfirmationModal } from 'actions/confirmationModal';
import { getGraphQLClient } from 'utilities/graphql';

import ArchiveFolders from './ArchiveFolders.graphql';

export function archiveFoldersGraphQL(folders, isArchived) {
  return dispatch => {
    const gqlClient = getGraphQLClient();

    gqlClient
      .mutate({
        mutation: ArchiveFolders,
        variables: {
          folderIds: folders.map(f => f.id),
          isArchived,
        },
        update: (cache, { data }) => {
          const updatedFolders = data?.result?.folders;

          if (updatedFolders) {
            updatedFolders.forEach(folder => {
              const normalizedId = cache.identify({
                id: folder.id,
                __typename: 'RegularUserFolder',
              });

              cache.evict({ id: normalizedId });
              cache.gc();
            });

            cache.gc();
          }
        },
      })
      .then(() => {
        const action = isArchived ? 'archived' : 'unarchived';

        if (folders.length === 1) {
          dispatch(
            showConfirmationModal(`${folders[0].name} successfully ${action}`)
          );
        } else if (folders.length > 1) {
          dispatch(
            showConfirmationModal(
              `${folders.length} folders successfully ${action}`
            )
          );
        }
      });
  };
}
